// Bundle Selector Script
(function () {
  // HTML injectie
  function injectHTML() {
    var bundleHTML = 
      '<div class="bundle-container">' +
      '<b class="bundle-title">Stelle dein Lieblingsbündel zusammen</b>' + 
      '<div id="fragrance1" class="fragrance-select"></div>' +
      '<div id="fragrance2" class="fragrance-select"></div>' +
      '<div id="fragrance3" class="fragrance-select"></div>' +
      '</div>';

    var target = document.querySelector('[data-block-id*="simple_bundles_kits_infinite_options_selector"]');
    if (target) {
      // Vind de eerste child in het block waar we voor willen plaatsen
      var targetElement = target.querySelector('#simple-bundles-io-options');
      if (targetElement) {
        targetElement.insertAdjacentHTML('beforebegin', bundleHTML);
        targetElement.style.display = 'unset';
      } else {
        // Fallback naar het block zelf als we het specifieke element niet kunnen vinden
        target.insertAdjacentHTML('afterbegin', bundleHTML);
      }
    }
  }

  

  // Standaard selecties voor initiële staat
  const defaultSelection = ['101', '202', '306'];

  // Debug logging functie
  function logDebug(message, data) {
    console.log(`%c[Bundle Debug] ${message}`, 'background:#f0f0f0;color:#333', data || '');
  }

  function triggerChange(element) {
    logDebug(`Trigger change op element:`, element.id);
    const event = new Event('change', { bubbles: true });
    element.dispatchEvent(event);
    element.dispatchEvent(new Event('input', { bubbles: true }));
  }

  function getCorrectProductId(index) {
    // Bepaal eerst de juiste product IDs door te zoeken in de DOM
    // Dit is robuuster dan vaste IDs gebruiken
    if (index === 0) return 'product-1';

    // Voor product 2 en 3, zoek naar alle select elementen en vind de juiste
    const allSelects = document.querySelectorAll('#simple-bundles-io-options select');
    logDebug(`Gevonden select elementen: ${allSelects.length}`);

    // Array van alle product IDs voor debugging
    const allSelectIds = Array.from(allSelects).map(s => s.id);
    logDebug(`Alle select IDs:`, allSelectIds);

    // Als we de conventie willen volgen maar de exacte ID moet controleren
    if (index === 1) {
      // Zoek naar het tweede product select element (vaak 'product-2' of 'product-2-')
      const product2Select = Array.from(allSelects).find(s =>
        s.id.startsWith('product-2') || (s.id !== 'product-1' && s.id.includes('product'))
      );
      return product2Select ? product2Select.id : null;
    } else if (index === 2) {
      // Zoek naar het derde product select element
      const product3Select = Array.from(allSelects).find(s =>
        s.id.startsWith('product-3') ||
        (s.id !== 'product-1' && s.id !== getCorrectProductId(1) && s.id.includes('product'))
      );
      return product3Select ? product3Select.id : null;
    }

    return null;
  }

  function initializeSelects() {
    const selects = document.querySelectorAll('#simple-bundles-io-options select');
    logDebug(`Initializing selects, found: ${selects.length}`);

    // Log alle select IDs voor debugging
    selects.forEach((select, i) => {
      logDebug(`Select ${i + 1} ID: ${select.id}`);
    });

    // Eerst alle 'selected' attributen verwijderen
    selects.forEach(select => {
      Array.from(select.options).forEach(option => {
        option.removeAttribute('selected');
      });
    });

    selects.forEach((select, index) => {
      const preferredValue = defaultSelection[index];
      logDebug(`Selectie ${index + 1}: zoek naar waarde startend met ${preferredValue} in ${select.id}`);

      // Zoek de voorkeursoptie (nu met betere value matching)
      const preferredOption = Array.from(select.options).find(option =>
        option.value.startsWith(preferredValue) &&
        !option.disabled &&
        parseInt(option.dataset.inventory) > 0 &&
        !option.value.toLowerCase().includes('5ml sample')
      );

      if (preferredOption) {
        logDebug(`Gevonden voorkeursoptie voor select ${index + 1}:`, preferredOption.value);
        select.value = preferredOption.value;
        preferredOption.selected = true;
        select.selectedIndex = preferredOption.index;
        triggerChange(select);
        return;
      } else {
        logDebug(`Geen voorkeursoptie gevonden voor select ${index + 1}`);
      }

      // Fallback naar eerste beschikbare optie
      const availableOption = Array.from(select.options)
        .find(option =>
          !option.disabled &&
          parseInt(option.dataset.inventory) > 0 &&
          option.value &&
          !option.value.toLowerCase().includes('5ml sample')
        );

      if (availableOption) {
        logDebug(`Fallback naar beschikbare optie voor select ${index + 1}:`, availableOption.value);
        select.value = availableOption.value;
        availableOption.selected = true;
        select.selectedIndex = availableOption.index;
        triggerChange(select);
      } else {
        logDebug(`Geen beschikbare optie gevonden voor select ${index + 1}`);
      }
    });

    // Extra verificatie na delay
    setTimeout(() => {
      selects.forEach((select, index) => {
        logDebug(`Verificatie voor select ${index + 1}, huidige waarde:`, select.value);

        const preferredValue = defaultSelection[index];
        if (!select.value || !select.value.startsWith(preferredValue)) {
          logDebug(`Selectie voor index ${index} is niet correct toegepast. Huidige waarde: ${select.value}`);

          // Probeer selectie opnieuw toe te passen
          const preferredOption = Array.from(select.options).find(option =>
            option.value.startsWith(preferredValue) &&
            !option.disabled &&
            parseInt(option.dataset.inventory) > 0 &&
            !option.value.toLowerCase().includes('5ml sample')
          );

          if (preferredOption) {
            logDebug(`Nieuw poging met optie:`, preferredOption.value);
            select.value = preferredOption.value;
            preferredOption.selected = true;
            select.selectedIndex = preferredOption.index;
            triggerChange(select);
          }
        }
      });
    }, 100);
  }

  function waitForElement(selector) {
    return new Promise(function (resolve) {
      // Controleer eerst of document.body bestaat
      if (!document.body) {
        logDebug('document.body is nog niet beschikbaar, wacht op DOMContentLoaded');
        document.addEventListener('DOMContentLoaded', function() {
          waitForElement(selector).then(resolve);
        });
        return;
      }
      
      if (document.querySelector(selector)) {
        logDebug(`Element direct gevonden: ${selector}`);
        return resolve(document.querySelector(selector));
      }

      logDebug(`Wachten op element: ${selector}`);
      var observer = new MutationObserver(function (mutations) {
        if (document.querySelector(selector)) {
          logDebug(`Element gevonden via observer: ${selector}`);
          observer.disconnect();
          resolve(document.querySelector(selector));
        }
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    });
  }

  function parseFragrances() {
    var fragrances = [];
    var options = document.querySelectorAll('#product-1 option');

    options.forEach(function (option) {
      if (option.value && !option.value.toLowerCase().includes('5ml sample')) {
        var id = parseInt(option.value.split(' ')[0]);
        var type = 'UNISEX';
        if (id >= 100 && id < 200) type = 'MEN';
        if (id >= 200 && id < 300) type = 'WOMEN';
        if (id >= 300) type = 'UNISEX';

        fragrances.push({
          id: option.value,
          name: option.textContent.trim(),
          type: type,
          inventory: option.disabled ? 0 : (parseInt(option.dataset.inventory) || 0),
          isBestSeller: parseInt(option.dataset.inventory) > 50
        });
      }
    });

    logDebug(`Parsed ${fragrances.length} fragrances`);
    window.parsedFragrances = fragrances;
    return fragrances;
  }

  var selectedFragrances = [null, null, null];

  function createFragranceSelector(containerId, index) {
    var container = document.getElementById(containerId);
    if (!container) {
      logDebug(`Container niet gevonden: ${containerId}`);
      return;
    }

    var fragrances = window.parsedFragrances || [];
    if (fragrances.length === 0) {
      logDebug('Geen geuren beschikbaar');
      return;
    }

    var activeFilter = 'ALL';

    var button = document.createElement('button');
    button.className = 'select-button';

    // Bepaal het juiste select element ID
    const correctSelectId = getCorrectProductId(index);
    logDebug(`Correct select ID voor index ${index}: ${correctSelectId}`);

    // Direct de geselecteerde geur tonen
    var initialSelect = document.getElementById(correctSelectId);
    var initialValue = initialSelect ? initialSelect.value : '';
    var initialFragrance = fragrances.find(f => f.id === initialValue);

    logDebug(`Initiele waarde voor ${containerId}: ${initialValue}`);

    button.innerHTML =
      '<span>' + (initialFragrance ? initialFragrance.name : 'Selecteer een geur') +
      (initialFragrance && initialFragrance.isBestSeller ? '<span class="best-seller">Beliebt</span>' : '') + '</span>' +
      '<svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">' +
      '<path d="M4.18179 6.18181C4.35753 6.00608 4.64245 6.00608 4.81819 6.18181L7.49999 8.86362L10.1818 6.18181C10.3575 6.00608 10.6424 6.00608 10.8182 6.18181C10.9939 6.35755 10.9939 6.64247 10.8182 6.81821L7.81819 9.81821C7.64245 9.99395 7.35753 9.99395 7.18179 9.81821L4.18179 6.81821C4.00605 6.64247 4.00605 6.35755 4.18179 6.18181Z" fill="currentColor" fill-rule="evenodd" clip-rule="evenodd"></path>' +
      '</svg>';

    var dropdown = document.createElement('div');
    dropdown.className = 'dropdown';

    var filterButtons = document.createElement('div');
    filterButtons.className = 'filter-buttons';
    filterButtons.innerHTML =
      '<button class="filter-btn active" data-type="ALL">ALLES</button>' +
      '<button class="filter-btn" data-type="MEN">HEREN</button>' +
      '<button class="filter-btn" data-type="WOMEN">DAMES</button>' +
      '<button class="filter-btn" data-type="UNISEX">UNISEX</button>';

    var dropdownItems = document.createElement('div');
    dropdownItems.className = 'dropdown-items';
    dropdown.appendChild(filterButtons);
    dropdown.appendChild(dropdownItems);

    function updateDropdownItems() {
      dropdownItems.innerHTML = '';
      var filteredFragrances = activeFilter === 'ALL'
        ? fragrances
        : fragrances.filter(function (f) { return f.type === activeFilter; });

      filteredFragrances.forEach(function (fragrance) {
        var item = document.createElement('div');
        item.className = 'dropdown-item';

        var stockInfo = '';
        if (fragrance.inventory <= 0) {
          stockInfo = '<span class="out-of-stock">Uitverkocht</span>';
          item.classList.add('disabled');
        } else if (fragrance.inventory < 10) {
          stockInfo = '<span class="low-stock">Noch ' + fragrance.inventory + ' auf Lager</span>';
        }

        item.innerHTML =
          '<div>' +
          fragrance.name +
          (fragrance.isBestSeller ? '<span class="best-seller">Beliebt</span>' : '') +
          stockInfo +
          '</div>';

        if (fragrance.inventory > 0) { // We controleren alleen of het op voorraad is
          item.onclick = function () {
            selectedFragrances[index] = fragrance; // We houden dit bij voor toekomstige functionaliteit
            button.innerHTML =
              '<span>' + fragrance.name +
              (fragrance.isBestSeller ? '<span class="best-seller">Beliebt</span>' : '') + '</span>' +
              '<svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">' +
              '<path d="M4.18179 6.18181C4.35753 6.00608 4.64245 6.00608 4.81819 6.18181L7.49999 8.86362L10.1818 6.18181C10.3575 6.00608 10.6424 6.00608 10.8182 6.18181C10.9939 6.35755 10.9939 6.64247 10.8182 6.81821L7.81819 9.81821C7.64245 9.99395 7.35753 9.99395 7.18179 9.81821L4.18179 6.81821C4.00605 6.64247 4.00605 6.35755 4.18179 6.18181Z" fill="currentColor" fill-rule="evenodd" clip-rule="evenodd"></path>' +
              '</svg>';

            // Gebruik de gecorrigeerde product ID's
            const selectId = getCorrectProductId(index);
            logDebug(`Selectie maken voor index ${index} met select ID: ${selectId}`);

            var shopifySelect = document.getElementById(selectId);
            if (shopifySelect) {
              logDebug('Debug - Voor selectie:', {
                selectieNummer: index + 1,
                geurNaam: fragrance.name,
                oudeWaarde: shopifySelect.value,
                nieuweWaarde: fragrance.id
              });

              // Update alle selected attributes
              Array.from(shopifySelect.options).forEach(function (opt) {
                opt.removeAttribute('selected');
              });

              var selectedOption = Array.from(shopifySelect.options).find(function (opt) {
                return opt.value === fragrance.id;
              });

              if (selectedOption) {
                selectedOption.selected = true;
                shopifySelect.selectedIndex = selectedOption.index;
                shopifySelect.value = fragrance.id;
                triggerChange(shopifySelect);

                logDebug(`Optie geselecteerd: ${selectedOption.value}`);
              } else {
                logDebug(`Geen overeenkomende optie gevonden voor ${fragrance.id} in ${selectId}`);
              }

              setTimeout(function () {
                // Gebruik de correcte product IDs voor logging
                const product1Id = getCorrectProductId(0);
                const product2Id = getCorrectProductId(1);
                const product3Id = getCorrectProductId(2);

                logDebug('Debug - Na selectie:', {
                  product1: document.getElementById(product1Id) ? document.getElementById(product1Id).value : 'niet gevonden',
                  product2: document.getElementById(product2Id) ? document.getElementById(product2Id).value : 'niet gevonden',
                  product3: document.getElementById(product3Id) ? document.getElementById(product3Id).value : 'niet gevonden'
                });
              }, 500);
            } else {
              logDebug(`FOUT: Geen Shopify select gevonden met ID: ${selectId}`);
            }

            dropdown.classList.remove('active');
          };
        } else {
          item.classList.add('disabled'); // Alleen disabled als niet op voorraad
        }

        dropdownItems.appendChild(item);
      });
    }

    filterButtons.querySelectorAll('.filter-btn').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        filterButtons.querySelectorAll('.filter-btn').forEach(function (b) {
          b.classList.remove('active');
        });
        btn.classList.add('active');
        activeFilter = btn.dataset.type;
        updateDropdownItems();
      });
    });

    button.onclick = function (e) {
      e.preventDefault();
      e.stopPropagation();

      // Sluit eerst alle andere dropdowns voordat we deze openen
      document.querySelectorAll('.dropdown').forEach(function (otherDropdown) {
        if (otherDropdown !== dropdown) {
          otherDropdown.classList.remove('active');
        }
      });

      dropdown.classList.toggle('active');
      updateDropdownItems();
    };

    container.appendChild(button);
    container.appendChild(dropdown);
  }

  function createSelectors() {
    logDebug('Creëren van geur selectoren');
    createFragranceSelector('fragrance1', 0);
    createFragranceSelector('fragrance2', 1);
    createFragranceSelector('fragrance3', 2);

    document.addEventListener('click', function (e) {
      if (!e.target.closest('.fragrance-select')) {
        document.querySelectorAll('.dropdown').forEach(function (dropdown) {
          dropdown.classList.remove('active');
        });
      }
    });
  }

  // Wacht tot de DOM geladen is
  function init() {
    // Injecteer eerst de HTML structuur
    injectHTML();
    
    // Wacht op alle benodigde elementen en initialiseer dan
    Promise.all([
      waitForElement('.bundle-container'),
      waitForElement('#simple-bundles-io-options select')
    ]).then(function () {
      logDebug('Benodigde elementen geladen, start initialisatie');

      // Geef de DOM even tijd om volledig te laden
      setTimeout(() => {
        initializeSelects();
        parseFragrances();
        createSelectors();
      }, 200);
    });
  }

  // Start de initialisatie op basis van document ready state
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();